import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmptyTableComponent} from './empty-table/empty-table.component';
import {LoadingModule} from './loading/loading.module';
import {CpfCnpjComponent} from './cpfcnpj/cpf-cnpj.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {UploadComponent} from './upload/upload.component';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {MessagesModule} from 'primeng/messages';
import {MapaCoreModule} from '@mapa/core';
import {GalleriaModule} from 'primeng/galleria';


@NgModule({
    declarations: [
        EmptyTableComponent,
        CpfCnpjComponent,
        UploadComponent
    ],
    imports: [
        MapaCoreModule,
        GalleriaModule,
        TableModule,
        ButtonModule,
        MessagesModule,
        CommonModule,
        LoadingModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule
    ],
    exports: [
        EmptyTableComponent,
        LoadingModule,
        CpfCnpjComponent,
        UploadComponent
    ]
})
export class UiSharedModule {
}
